/*
  NUVA — Muestrario NUVA (página pública, no listada)
  ==========================================================================
  Filtros por categoría, drawer de detalle y lectura del enlace
  personalizado del vendedor (?vendedor=...&wa=...). El nombre se
  imprime SIEMPRE vía textContent (nunca innerHTML) y el WhatsApp se
  reduce a solo dígitos antes de usarse. Si falta cualquiera de los dos,
  nunca se sustituye por el WhatsApp general de NUVA: se muestra el
  texto de respaldo indicado por el editor del tema.
*/
(function () {
  'use strict';

  function onlyDigits(str) {
    return (str || '').replace(/\D/g, '');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-muestrario-root]');
    if (!root) return;

    var waMessage = root.getAttribute('data-wa-message') || '';
    var noVendorText = root.getAttribute('data-no-vendor-text') || '';
    var vendorPrefix = root.getAttribute('data-vendor-footer-prefix') || 'Vendido por ';

    /* ---------------- Enlace del vendedor ---------------- */
    var params = new URLSearchParams(window.location.search);
    var rawName = params.get('vendedor') || '';
    var rawWa = params.get('wa') || '';

    var safeName = rawName.trim().slice(0, 60);
    var safeWa = onlyDigits(rawWa);
    var hasVendor = safeName.length > 0 && safeWa.length >= 10;

    var waHref = '';
    if (hasVendor) {
      waHref = 'https://wa.me/' + safeWa + '?text=' + encodeURIComponent(waMessage);
    }

    var ctaButtons = Array.prototype.slice.call(document.querySelectorAll('[data-muestrario-cta]'));
    var noVendorEls = Array.prototype.slice.call(document.querySelectorAll('[data-muestrario-no-vendor]'));
    var vendorFooter = document.querySelector('[data-muestrario-vendor-footer]');

    if (hasVendor) {
      ctaButtons.forEach(function (btn) {
        btn.href = waHref;
        btn.hidden = false;
      });
      if (vendorFooter) {
        // textContent — nunca innerHTML — así el nombre nunca se interpreta como HTML.
        vendorFooter.textContent = vendorPrefix + safeName;
        vendorFooter.hidden = false;
      }
    } else {
      noVendorEls.forEach(function (el) {
        el.textContent = noVendorText;
        el.hidden = false;
      });
    }

    /* ---------------- Filtros ---------------- */
    var filterButtons = Array.prototype.slice.call(document.querySelectorAll('[data-muestrario-filter]'));
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-muestrario-card]'));
    var editorialBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-muestrario-editorial]'));

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterButtons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var category = btn.getAttribute('data-muestrario-filter');

        cards.forEach(function (card) {
          card.hidden = category !== 'all' && card.getAttribute('data-category') !== category;
        });
        editorialBlocks.forEach(function (block) {
          block.hidden = category !== 'all';
        });
      });
    });

    /* ---------------- Drawer de detalle ---------------- */
    var drawer = document.querySelector('[data-muestrario-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('[data-muestrario-drawer-panel]');
    var imgEl = drawer.querySelector('[data-muestrario-drawer-img]');
    var categoryEl = drawer.querySelector('[data-muestrario-drawer-category]');
    var nameEl = drawer.querySelector('[data-muestrario-drawer-name]');
    var colorRow = drawer.querySelector('[data-muestrario-drawer-color-row]');
    var colorEl = drawer.querySelector('[data-muestrario-drawer-color]');
    var sizesRow = drawer.querySelector('[data-muestrario-drawer-sizes-row]');
    var sizesEl = drawer.querySelector('[data-muestrario-drawer-sizes]');
    var priceEl = drawer.querySelector('[data-muestrario-drawer-price]');
    var statusEl = drawer.querySelector('[data-muestrario-drawer-status]');
    var drawerCta = drawer.querySelector('[data-muestrario-drawer-cta]');
    var closeEls = Array.prototype.slice.call(document.querySelectorAll('[data-muestrario-drawer-close]'));
    var lastTrigger = null;

    function openDrawer(trigger) {
      lastTrigger = trigger;
      var d = trigger.dataset;

      imgEl.src = d.image || '';
      imgEl.alt = d.imageAlt || '';
      categoryEl.textContent = d.categoryLabel || '';
      nameEl.textContent = d.name || '';

      if (d.color) {
        colorEl.textContent = d.color;
        colorRow.hidden = false;
      } else {
        colorRow.hidden = true;
      }

      if (d.sizes) {
        sizesEl.textContent = d.sizes;
        sizesRow.hidden = false;
      } else {
        sizesRow.hidden = true;
      }

      priceEl.textContent = d.price ? '$' + d.price + ' MXN' : 'Consulta con tu vendedor';
      statusEl.textContent = d.statusLabel || '';

      if (drawerCta) {
        if (hasVendor) {
          var itemMessage = waMessage + ' (' + (d.name || '') + (d.color ? ', ' + d.color : '') + ')';
          drawerCta.href = 'https://wa.me/' + safeWa + '?text=' + encodeURIComponent(itemMessage);
          drawerCta.hidden = false;
        } else {
          drawerCta.hidden = true;
        }
      }

      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      panel.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      var finish = function () {
        drawer.hidden = true;
        panel.removeEventListener('transitionend', finish);
      };
      panel.addEventListener('transitionend', finish);
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 320);
      if (lastTrigger) lastTrigger.focus();
    }

    function getFocusable() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null; });
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDrawer();
        return;
      }
      if (e.key === 'Tab') {
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-muestrario-detail-trigger]');
      if (trigger) openDrawer(trigger);
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
  });
})();
